/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {A11yModule} from '@angular/cdk/a11y';
/**
 * @deprecated
 */
export class StyleModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [A11yModule],
  exports: [A11yModule],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function StyleModule_tsickle_Closure_declarations() {
/** @type {?} */
StyleModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StyleModule.ctorParameters;
}


export {
  CdkMonitorFocus,
  FocusMonitor,
  FOCUS_MONITOR_PROVIDER,
  FocusOrigin,
} from '@angular/cdk/a11y';
export {applyCssTransform} from './apply-transform';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
